module.exports = __webpack_public_path__ + "static/media/greenKeys.8fbed517.svg";